module.exports = __webpack_public_path__ + "static/media/Mihika Dravid.a6092453.jpg";